var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._v(
      ' :max-height="300" max-height="calc(100vh - 350px)" :scroll-width="1200" //在mobile時，可以往右捲動 :max-height="200" :fixed-header="true" :max-height="200" :fixed-header="false" column width: "40%", width: 400, fixed: "left", //釘選欄 //超過長度變成... ellipsis: { showTitle: true, }, //超過長度變成... (但顯示2行) ellipsis: { showTitle: true, lineClamp: 2, }, --> '
    ),
    _c("div", { staticClass: "input-group", staticStyle: { width: "200px" } }, [
      _vm._m(0),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.searchText,
            expression: "searchText"
          }
        ],
        staticClass: "form-control",
        attrs: { type: "text", placeholder: "關鍵字" },
        domProps: { value: _vm.searchText },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.searchText = $event.target.value
          }
        }
      })
    ]),
    _c(
      "div",
      { staticStyle: { "background-color": "white", "max-width": "1280px" } },
      [
        _c("ve-table", {
          ref: "grid",
          style: { "word-break": _vm.wordBreak },
          attrs: {
            "row-style-option": _vm.rowStyleOption,
            "radio-option": _vm.radioOption,
            "checkbox-option": _vm.checkboxOption,
            "is-vertical-resize": true,
            columns: _vm.columns,
            "title-rows": _vm.tableConfig.titleRows,
            "table-data": _vm.filterDataSource,
            "show-vertical-border": true,
            "row-hover-color": "#eee",
            "row-click-color": "#edf7ff",
            "select-all": _vm.config.selectAll,
            "select-change": _vm.config.selectChange,
            "select-group-change": _vm.config.selectGroupChange,
            "paging-index": (_vm.config.pageIndex - 1) * _vm.config.pageSize,
            "is-loading": _vm.config.isLoading,
            "expand-option": _vm.expandOption,
            "row-key-field-name": "SystemId",
            "border-around": true,
            "border-x": true,
            "border-y": true,
            "sort-option": _vm.sortOption,
            "column-width-resize-option": _vm.columnWidthResizeOption,
            "cell-style-option": _vm.cellStyleOption
          }
        }),
        _c("ve-pagination", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showEmpty,
              expression: "!showEmpty"
            }
          ],
          attrs: {
            total: _vm.tableData.length,
            "page-size-option": [10, 50, 100],
            "page-size": 10
          }
        }),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showEmpty,
                expression: "showEmpty"
              }
            ],
            staticClass: "empty-data"
          },
          [_vm._v("查無資料!")]
        )
      ],
      1
    ),
    _c(
      "a",
      {
        staticClass: "btn btn-primary",
        attrs: { role: "button" },
        on: {
          click: function($event) {
            return _vm.btnTest1()
          }
        }
      },
      [_vm._v("hide column")]
    ),
    _c(
      "a",
      {
        staticClass: "btn btn-primary",
        attrs: { role: "button" },
        on: {
          click: function($event) {
            return _vm.btnTest2()
          }
        }
      },
      [_vm._v("show column")]
    ),
    _vm._v(" "),
    _c("br"),
    _c(
      "a",
      {
        staticClass: "btn btn-primary",
        attrs: { role: "button" },
        on: {
          click: function($event) {
            return _vm.btnTest3()
          }
        }
      },
      [_vm._v("radio select")]
    ),
    _c(
      "a",
      {
        staticClass: "btn btn-primary",
        attrs: { role: "button" },
        on: {
          click: function($event) {
            return _vm.btnTest4()
          }
        }
      },
      [_vm._v("radio select by id")]
    ),
    _c(
      "a",
      {
        staticClass: "btn btn-primary",
        attrs: { role: "button" },
        on: {
          click: function($event) {
            return _vm.btnTest5()
          }
        }
      },
      [_vm._v("radio unselect ")]
    ),
    _vm._v(" "),
    _c("br"),
    _c(
      "a",
      {
        staticClass: "btn btn-primary",
        attrs: { role: "button" },
        on: {
          click: function($event) {
            return _vm.btnTest6()
          }
        }
      },
      [_vm._v("checkbox select")]
    ),
    _c(
      "a",
      {
        staticClass: "btn btn-primary",
        attrs: { role: "button" },
        on: {
          click: function($event) {
            return _vm.btnTest7()
          }
        }
      },
      [_vm._v("checkbox select all")]
    ),
    _c(
      "a",
      {
        staticClass: "btn btn-primary",
        attrs: { role: "button" },
        on: {
          click: function($event) {
            return _vm.btnTest8()
          }
        }
      },
      [_vm._v("checkbox unselect all")]
    ),
    _vm._v(" "),
    _c("br"),
    _c(
      "a",
      {
        staticClass: "btn btn-primary",
        attrs: { role: "button" },
        on: {
          click: function($event) {
            return _vm.btnTest9()
          }
        }
      },
      [_vm._v("顯示 查無資料")]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "input-group-append" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-outline-secondary border-start-0 border ms-n3",
          attrs: { type: "button" }
        },
        [_c("i", { staticClass: "fa fa-search" })]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }